export enum InternalNoteType {
    Warn = 'WARN',
    Info = 'INFO',
    Danger = 'DANGER',
    Success = 'SUCCESS',
}
